import {useFormik} from "formik";
import * as Yup from 'yup'
import {useContext, useEffect, useState} from "react";
import CheckboxesComponent from "./CheckboxesComponent";
import FormFooter from "../../components/FormFooter";
import {MyContext} from "../../context/myContext";
import FormikInput from "../../components/FormikInput";
import {useDispatch, useSelector} from "react-redux";
import {selectAllCities, selectRegisterBtnType} from "../common-states/commonStatesSlice";
import {addOrEditUser, selectUserServerError} from "./userSlice";

const AddUserForm = () => {
    const {showEditForm, showForm, formTitle, initialState, initialInputState, userId} = useContext(MyContext)
    const [state, setState] = useState(initialState)
    const dispatch = useDispatch()
    const registerBtnType = useSelector(selectRegisterBtnType)
    const serverError = useSelector(selectUserServerError)
    const allCities = useSelector(selectAllCities)

    const formik = useFormik({
        initialValues: initialInputState,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            tel: Yup.number().required('شماره تلفن را وارد کنید').typeError('عدد معتبر است'),
            name: Yup.string().required('نامتان را وارد کنید'),
            password: Yup.string().when(formTitle, {
                is: (val) => val === 'تعریف کاربر جدید',
                then: (schema) =>  schema.required('رمز عبور را وارد کنید'),
                otherwise: (schema) => schema.notRequired()
            }), // To not validate when it is editForm
            username: Yup.string().matches(/^[a-zA-Z0-9_.-][\w\s]*$/, "به انگلیسی وارد کنید").required('نام کاربری را وارد کنید'),
            level: Yup.string().required('سطح دسترسی را تعیین کنید'),
        }),
        onSubmit: values => {
            if(values.level === 'کاربر' && state.addedCities.length === 0){
                return setState({...state, error: {...state.error, showNoneExistCities: true}})
            }
            let city_permissions = state.addedCities.map((item) => {
                return {city_id: item.city_id}
            })
            let array = values.checked;
            let allPermissions = {can_add_driver: array.includes('addDriver'), can_add_manual_tanker_request: array.includes('addWaterReq'), can_add_nomad: array.includes('addNomad'),
                can_confirm_tanker_request_arrival: array.includes('manualDeliver'), can_delete_driver: array.includes('delDriver'), can_delete_nomad: array.includes('delNomad'),
                can_delete_tanker_request: array.includes('delReq'), can_edit_driver: array.includes('editDriver'), can_edit_nomad: array.includes('editNomad'),
                can_export_excel: array.includes('getExcel'), can_reject_tanker_request: array.includes('rejectReq'), can_see_reports: array.includes('seeingReport'),
                user_id: localStorage.getItem('userId'), user_permission_id: localStorage.getItem('userId')}

            let commonData = {
                location_permissions: city_permissions,
                mobile: values.tel,
                name: values.name,
                username: values.username,
                permissions: allPermissions
            }
            dispatch(addOrEditUser({data: commonData, registerBtnType, userId, password: values.password, dispatch}))
        }
    })

    const handleSelectCity = (e) => {
        setState({...state, selectedCity: e.target.value})
    }
    const handleClickAddButton = () => {
        if(state.selectedCity !== 0){
            if(state.addedCities.find(i => i.city_id === Number(state.selectedCity))) {
                setState({...state, error:{...state.error, showExtraCityError: true}})
            }
            else {
                let addedCity = allCities.filter((item) => {
                    return item.city_id === Number(state.selectedCity)
                })
                setState({...state, addedCities: [...state.addedCities, addedCity[0]], error: {serverError: '', showExtraCityError: false, showNoneExistCities: false}})
            }
        }
    }
    const handleRemoveCity = (id) => {
        let updatedCities = state.addedCities.filter((item) => {
            return item.city_id !== id
        })
        setState({...state, addedCities: updatedCities, error: {...state.error, showExtraCityError: false}})
    }
    const handleResetForm = () => {
        formik.resetForm()
        setState({addedCities: [], selectedCity: 0,  error: {serverError: '', showExtraCityError: false, showNoneExistCities: false}})
    }

    useEffect(() => {
        formik.resetForm()
        setState({addedCities: [], selectedCity: 0,  error: {serverError: '', showExtraCityError: false, showNoneExistCities: false}})
        // eslint-disable-next-line
    }, [showEditForm === false, showForm === false])

    useEffect(() => {
        setState({...state, addedCities: [], selectedCity: 0})
        // eslint-disable-next-line
    }, [formik.values.level === 'مدیر کل'])

    useEffect(() => {
        setState(initialState)
        // eslint-disable-next-line
    }, [initialState])

    const inputData = [
        {name: 'tel', placeholder: 'تلفن همراه', hint: 'همراه'}, {name: 'name', placeholder: 'نام و نام خانوادگی', hint: 'نام'}, {name: 'password', placeholder: 'رمز عبور', hint: 'رمز'}, {name: 'username', placeholder: 'نام کاربری(انگلیسی)', hint: 'نام کاربری'},
    ]

    return(
        <form className='add-user-form' onSubmit={formik.handleSubmit}>
            <div className='form-flex'>
                <FormikInput data={inputData} formik={formik} handleChange={formik.handleChange} />
                {formik.values.level === 'کاربر' &&
                    <div>
                        <select name='province' value={formik.values.province} onChange={formik.handleChange}>
                            <option value='' disabled>انتخاب استان</option>
                            <option value='خراسان جنوبی'>خراسان جنوبی</option>
                        </select>
                        <span>*</span>
                        {formik.touched.province && formik.errors.province ? <p className='error'>{formik.errors.province}</p> : null}
                    </div>
                }
                <div className={`${formTitle === 'ویرایش کاربر' && formik.values.level === 'کاربر' && 'centered-select'}`}>
                    <select name='level' value={formik.values.level} onChange={formik.handleChange}>
                        <option value='' disabled>سطح دسترسی</option>
                        <option value='مدیر کل'>مدیر کل</option>
                        <option value='کاربر'>کاربر</option>
                    </select>
                    <span>*</span>
                    {formik.touched.level && formik.errors.level ? <p className='error'>{formik.errors.level}</p> : null}
                </div>
                {formik.values.level === 'کاربر' &&
                    <>
                        <div>
                            {state.addedCities.length ?
                                <div className='selected-cities-container'>
                                    {state.addedCities.map((item, index) => {
                                        return <button type='button' key={index}>{item.name}<i className="fa fa-times close-icon" onClick={() => handleRemoveCity(item.city_id)}></i></button>
                                    })}
                                </div> :
                                <p className='selected-cities-default'>شهرهای دسترسی داده شده</p>
                            }
                            <span>*</span>
                            {state.error.showNoneExistCities ? <p className='empty-city-error'>شهر اضافه کنید</p> : null}
                            {state.error.showExtraCityError ? <p className='extra-city-error'>شهر تکراری نمی توانید انتخاب کنید.</p> : null}
                        </div>
                        <div>
                            <select name='city' className='city' value={state.selectedCity} onChange={handleSelectCity}>
                                <option value='0' disabled>افزودن شهر</option>
                                {allCities.map((item, index) => {
                                    return <option key={index} value={item.city_id}>{item.name}</option>
                                })}
                            </select>
                            <span>*</span>
                            <button type='button' className='add-city' onClick={handleClickAddButton}><span>+</span></button>
                        </div>
                        <span className='user-alert'>برای کاربر باید حداقل یک شهر اضافه کنید.</span>
                    </>
                }
                {serverError && <p className='server-error'>{serverError}</p>}
            </div>
            <p className='select-access-title'>انتخاب دسترسی ها</p>
            <CheckboxesComponent handleChange={formik.handleChange} formik={formik} />
            <FormFooter handleReset={handleResetForm} />
        </form>
    )
}
export default AddUserForm